export default __webpack_public_path__ + "static/media/notebook_reduced.610645bd.jpg";